// extracted by mini-css-extract-plugin
module.exports = {"line-version-status-title":"VersionTitle_line-version-status-title__1gpKD"};